module.exports = "https://cdn2-fs.clearscore.com/flux/images/bc71a925c099a954bbb73d322b4f91bc.jpg";